import { render, staticRenderFns } from "./AppTableRow.vue?vue&type=template&id=70f1310c&scoped=true&"
import script from "./AppTableRow.vue?vue&type=script&lang=js&"
export * from "./AppTableRow.vue?vue&type=script&lang=js&"
import style0 from "./AppTableRow.vue?vue&type=style&index=0&id=70f1310c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f1310c",
  null
  
)

export default component.exports